// extracted by mini-css-extract-plugin
export var container = "RightSideFeedCell-module--container--gqemx";
export var link = "RightSideFeedCell-module--link--f+ZDy";
export var cardTitle = "RightSideFeedCell-module--cardTitle--gitct";